var popin = {

	ui: {},

	init: function() {
		this.bindUI();
		this.bindEvents();
	},

	bindUI: function() {
		this.ui.$document = $(document);

		this.ui.$displayPopin = $(".js-display-popin");
		this.ui.$popin = $(".js-popin");
		this.ui.$popinClose = $(".js-popin-close");
		this.ui.$popinContainer = $('.js-popin-container');
	},

	bindEvents: function() {
		this.ui.$displayPopin.on('click', this.popinOpen.bind(this));
		this.ui.$popinClose.on('click', this.popinClose.bind(this));
		this.ui.$popin.on('click', this.popinClose.bind(this));
		this.ui.$popinContainer.on('click', this.popinClose.bind(this));
	},

	popinOpen: function(e) {
		let self = this;
		let $this = $(e.target);
		
		e.preventDefault();
		$(".js-popin"+$this.attr('href')).fadeIn(200);
	},

    popinClose: function(e) {
		let $this = $(e.target);
		let $targetPopin;
		e.stopPropagation();
		
		if($this.hasClass("js-popin")){
			$targetPopin = $this;
		} else {
			$targetPopin = $this.parents('.js-popin');
		}
		$targetPopin.fadeOut(200)
    }

};

module.exports = popin;
